<template>
   <NuxtLayout>
      <NuxtLoadingIndicator color="#f6b035" />
      <NuxtPage />
   </NuxtLayout>
</template>
